import React, { useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { MenuItem, Select } from "@mui/material";

const CountryCodeSelector = ({ countryCodes, onCountryCodeChange, initialCountryCode }) => {
    const [selectedCode, setSelectedCode] = useState(initialCountryCode || (countryCodes?.[0]?.code || ''));

    const handleChange = (event) => {
        const newCode = event.target.value;
        setSelectedCode(newCode);
        onCountryCodeChange(newCode);
    };

    return (
        <div className="country-code-select-container">
            <Select
                value={selectedCode}
                onChange={handleChange}
                className="country-code-select"
            >
                {countryCodes && countryCodes.map((country) => (
                    <MenuItem key={country.code} value={country.code} style={{ display: 'flex', alignItems: 'center' }}>
                        <ReactCountryFlag countryCode={country.mappedFlag.toLowerCase()} svg style={{ width: '2em', height: '1.5em', marginRight: '0.5em' }} />
                        {country.code}
                    </MenuItem>
                ))}
                {!countryCodes && (
                    <option value="" disabled>Cargando códigos...</option>
                )}
            </Select>
        </div>
    );
};

export default CountryCodeSelector;